<script setup lang="ts">
import { useLocale } from '@/plugins/translation';
import { storeToRefs } from 'pinia';
import useQuizStore from '@/store/quiz';

const { t } = useLocale();
const { loadingText } = storeToRefs(useQuizStore());
</script>
<template>
  <div class="d-flex align-center justify-center flex-dir-column text-center column nopad small-12 quiz-loader">
    <v-progress-circular class="mr-3" indeterminate color="primary"></v-progress-circular>
    <span>{{ t(loadingText) }}...</span>
  </div>
</template>

<style lang="scss" scoped>
.quiz-loader {
  min-height: 340px;

  .spinner-container__library {
    position: relative;
    top: 0;
    left: 0;
    height: auto !important;
  }
}
</style>
